module.exports = __webpack_public_path__ + "static/1732685807992/media/nightowl_logo.2467b6ad.svg";